import { useStores } from '../stores/useStores';

// Indiana (cash-winnings) mode: SC redeems as cash, not redeemable SC. `wsc_available` is resolved
// server-side (with the full redis userStats context) and returned on the profile, so we read it from
// there instead of re-evaluating the flag client-side. `?? true` keeps cash mode off until the profile
// loads, matching the old flag fallback.
export const useCashWinningsMode = (): boolean => {
  const { userStore } = useStores();
  return !(userStore.profile?.isWscAvailable ?? true);
};
